import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { Placeholder } from '../models/placeholder.model'

@Injectable({
  providedIn: 'root'
})
export class PlaceholderService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = `${environment.referenceApiUrl}/placeholder`

  public getPlaceholders(): Observable<Placeholder[]> {
    return this.http.get<Placeholder[]>(this.apiUrl)
  }
}
